import React from 'react';
import PropTypes from 'prop-types';

import Store from '@app/store';

import Icon from '@component/icon';

import { SILVER_SAND } from '@constant/colors';

import Subnav from './subnav';

export default class Item extends React.Component {
  static propTypes = {
    trk: PropTypes.string,
    path: PropTypes.string,
    items: PropTypes.array,
    onClick: PropTypes.func,
    className: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,
    backButton: PropTypes.bool,
    hasChannelName: PropTypes.bool,
  };

  static defaultProps = {
    hasChannelName: false,
  };

  triggerClick(forcedClose) {
    const path = this.props.path || this.props.items[0].path;
    if (this.props.onClick) {
      this.props.onClick(path, forcedClose);
    }
  }

  render() {
    const { route } = Store.getState();
    let activeChild = false;
    let className = this.props.className || 'nav__item';
    let children = [];
    let path = this.props.path;

    // Does this menu item have any children?
    if (this.props.items) {
      // Create an <Item> for every child
      for (const subItem of this.props.items) {
        let itemClassName = 'nav__subitem';

        // Is this item (or it's child page) currently "active" ?
        if (
          route.path.indexOf(subItem.path) > -1 ||
          (subItem.alternativePaths &&
            subItem.alternativePaths.indexOf(route.path) > -1)
        ) {
          itemClassName += ' nav__subitem--active';
          activeChild = true;
        }

        // Add it to the list
        children.push(
          <Item key={subItem.path} className={itemClassName} {...subItem} />
        );
      }

      if (!path) {
        path = this.props.items[0].path;
      }
    }

    // If there are children, render the children element
    if (children.length) {
      className += ' nav_item--expanded';
      children = (
        <Subnav
          key={'subitems-' + this.props.name}
          containsActive={activeChild}
        >
          {children}
        </Subnav>
      );
    } else {
      children = null;
    }

    // If it contains an active item, or is active itself, update className
    let forcedClose = false;
    if (activeChild || (route.path && route.path === this.props.path)) {
      className += ' nav__item--active';
      forcedClose = true;
    }

    let backButton = null;
    if (this.props.backButton) {
      backButton = (
        <Icon
          className="nav__back-icon"
          color={SILVER_SAND}
          type="ArrowCircle"
        />
      );
    }

    let image = null;
    if (this.props.image) {
      image = (
        <div
          className="nav__image"
          style={{ backgroundImage: 'url(' + this.props.image + ')' }}
          onClick={this.triggerClick.bind(this, forcedClose)}
        />
      );
    }

    if (this.props.trk) {
      path += `?trk=${this.props.trk}`;
    }

    const linkClasses = ['nav__label'];
    if (this.props.hasChannelName) {
      linkClasses.push('nav__label--channel');
    }

    let link = (
      <a href={path} className={linkClasses.join(' ')}>
        {this.props.name}
      </a>
    );
    if (forcedClose) {
      link = (
        <span
          onClick={this.triggerClick.bind(this, forcedClose)}
          className={linkClasses.join(' ')}
        >
          {this.props.name}
        </span>
      );
    }

    // Return the Item as a TransitionGroup because it needs to be one for the subnav sliding transition
    return (
      <li className={className}>
        {backButton}
        {link}
        {image}
        {children}
      </li>
    );
  }
}
